type BffRequestOptions = {
  credentials?: RequestCredentials
}

type BffApiRequestParams<TResult> = {
  request: (requestOptions?: BffRequestOptions) => Promise<TResult>
}

const loginIfNoAuth = async () => {
  const authStore = useAuthStore()

  if (authStore.isAuthenticated) {
    return
  }

  await authStore.login()

  if (!authStore.isAuthenticated) {
    throw new Error('Service unavailable. Please try again later.')
  }
}

export const requestBffApi = async <TResult>({
  request
}: BffApiRequestParams<TResult>): Promise<TResult> => {
  return request()
}

export const requestAuthenticatedBffApi = async <TResult>({
  request
}: BffApiRequestParams<TResult>): Promise<TResult> => {
  await loginIfNoAuth()

  return requestBffApi({
    request: () => request({ credentials: 'include' })
  })
}
